import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AnchorModel } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-page-alloggio',
  templateUrl: './page-alloggio.component.html',
  styleUrls: ['./page-alloggio.component.scss']
})
export class PageAlloggioComponent implements OnInit {

  @Input() node: any;
  @Input() anchorItems: AnchorModel[] = [];
  @Input() isSecondLevelUp: boolean = false;
  public idAnchor: string = '';
  public block: any;
  public imgPath = "";
  public isSpinner: boolean = false;
  public titlePage: string = '';
  public prezzo: string = '';
  public isCollapseHeader: boolean = false;
  public isShowLocalMenu: any;
  public dataFieldTaxonomies: any[] = [];
  //MODALE SHARE
  public onHoverShare: boolean = false;

  constructor(
    private helpersService: HelpersService,
    public nodeService: NodeService
  ) { }

  ngOnInit(): void {
    this.nodeService.getRowTypeView(this.node.langcode[0].value, this.node.field_oggetto_view[0].value, this.node.field_tipo_view[0].value, this.node.preview, this.node.nid[0].value).subscribe(resView => {
      this.block = resView[0];
      this.titlePage = this.helpersService.retriveLinkTagA(this.block.field_titolo, 'a').title;
      if (this.block.field_prezzo) {
        this.prezzo = this.block.field_prezzo.split('.')[0] + ' €';
      }
      this.setDataFields(this.block, this.prezzo);
    });
    this.isSpinner = true;
    this.helpersService.showLocalMenuBS.subscribe(value => {
      this.isShowLocalMenu = value;
    });
  }

  @HostListener('document:scroll', ['$event'])
  public onViewportScroll() {
    let boundingCollapse;
    if (this.isSpinner && this.node) {
      boundingCollapse = document.querySelector('.container-field-taxonomies')?.getBoundingClientRect();
    }
    if ((boundingCollapse && boundingCollapse.y < -40 && boundingCollapse.width > 767) || (boundingCollapse && boundingCollapse.y < -200 && boundingCollapse.width <= 767)) {
      this.isCollapseHeader = true;
    } else {
      this.isCollapseHeader = false;
    }
  }

  addNewAnchorItem(value: AnchorModel) {
    if (value.labelRow !== '') {
      this.anchorItems.push(value);
    }
    this.anchorItems.sort((a, b) => a.position - b.position);
    // this.idAnchor = this.anchorItems[0].idRow;
  }

  public openMenu(): void {
    this.helpersService.openLocalMenuBS.next(true);
  }

  private setDataFields(block: any, prezzo: string): void {
    if (block.field_categorie_alloggi.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_ALLOGGIO.CATEGORY_ACCOMMODATION',
          value: block.field_categorie_alloggi,
          isArray: true
        }
      ]
    }
    if (block.field_citta) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_ALLOGGIO.CITY',
          value: block.field_citta,
          isArray: false
        }
      ]
    }
    if (block.field_quartiere) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_ALLOGGIO.NEIGHBORHOOD',
          value: block.field_quartiere,
          isArray: false
        }
      ]
    }
    if (block.field_indirizzo) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_ALLOGGIO.ADDRESS',
          value: block.field_indirizzo,
          isArray: false
        }
      ]
    }
    if (block.field_piano) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_ALLOGGIO.FLOOR',
          value: block.field_piano,
          isArray: false
        }
      ]
    }
    if (prezzo) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_ALLOGGIO.PRICE',
          value: prezzo,
          isArray: false
        }
      ]
    }
    if (block.field_soluzione.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_ALLOGGIO.SOLUTION_FOR',
          value: block.field_soluzione.length === 2 ? block.field_soluzione[0] + ' e ' + block.field_soluzione[1] : block.field_soluzione[0],
          isArray: false
        }
      ]
    }
    if (block.field_riferimento_alloggio) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_ALLOGGIO.SOLUTION_REFERS_TO',
          value: block.field_riferimento_alloggio,
          isArray: false
        }
      ]
    }
  }
}
